import { render, staticRenderFns } from "./PositionSchemes.vue?vue&type=template&id=912e2d84&"
import script from "./PositionSchemes.vue?vue&type=script&lang=js&"
export * from "./PositionSchemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports